import { observer } from "mobx-react-lite";
import { useContext } from "react";

import {
  dataAttribute,
  DataAttributes,
  MessageBar,
  Text
} from "@bps/fluent-ui";
import { FieldCondition } from "@ui-components/form/FieldCondition.tsx";

import { appointmentFormNameOf } from "./AppointmentForm.types.ts";
import { AppointmentFormContext } from "./context/AppointmentFormContext.ts";

export interface RecurrenceRuleDisplayProps {
  hideInitialState: boolean;
}

export const RecurrenceRuleDisplay: React.FunctionComponent<RecurrenceRuleDisplayProps> =
  observer(({ hideInitialState = false }) => {
    const { isValidRRule, nextRecurrenceDates } = useContext(
      AppointmentFormContext
    );

    const { last, next } = nextRecurrenceDates || {};

    return (
      <FieldCondition when={appointmentFormNameOf("repeat")} is={true}>
        {next || last ? (
          <MessageBar>
            {next && (
              <Text
                block
                {...dataAttribute(DataAttributes.Element, "next-date-text")}
              >
                Next {last && next.hasSame(last, "day") ? " and final " : ""}
                appointment will be {next.toDayDefaultFormat()}
              </Text>
            )}
            {last && (!next || (next && next !== last)) && (
              <Text
                block
                {...dataAttribute(DataAttributes.Element, "last-date-text")}
              >
                Final appointment will be on the {last.toDayDefaultFormat()}
              </Text>
            )}
          </MessageBar>
        ) : (
          isValidRRule !== undefined &&
          !isValidRRule &&
          !hideInitialState && (
            <MessageBar>
              <Text
                block
                {...dataAttribute(DataAttributes.Element, "default-date-text")}
              >
                Set up series to view appointment information
              </Text>
            </MessageBar>
          )
        )}
      </FieldCondition>
    );
  });
